import React from 'react'
import { faFacebook,faSquareInstagram,faGithub,faLinkedin,faHtml5 } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-scroll'

export const Footer = () => {
  return (
    <div className='flex flex-col gap-3 bg-white justify-center items-center p-12'>
       <h2  className='  text-2xl md:text-3xl text-blue-800 font-bold'>Shivam Sharma</h2> 
       <ul className='text-black  text-sm md:text-lg font-semibold flex md:gap-4 gap-2'>
        <li> 
          <Link 
            to="home" 
            smooth={true} 
            spy={true} 
            >HOME
          </Link>
        </li>
       <li> 
          <Link 
            to="about" 
            smooth={true} 
            spy={true} 
            >ABOUT
          </Link>
        </li>
        <li> 
          <Link 
            to="skills" 
            smooth={true} 
            spy={true} 
            >SKILLS
          </Link>
        </li>
        <li> 
          <Link 
            to="project" 
            smooth={true} 
            spy={true} 
            >PROJECTS
          </Link>
        </li>
        <li> 
          <Link 
            to="contact" 
            smooth={true} 
            spy={true} 
            >CONTACT
          </Link>
        </li>
       </ul>
       <div className='text-blue flex gap-3 md:gap-5'>
                   <span ><a href="https://www.facebook.com/sagar.dhiman.3538/?fref=nf&pn_ref=story&_rdr" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook} className='text-black  md:text-2xl text-2xl lg:text-4xl hover:scale-110'/></a></span>
            <span ><a href="https://www.instagram.com/shivamshr01/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faSquareInstagram} className='text-black  md:text-2xl text-2xl lg:text-4xl hover:scale-110'/></a></span>
            <span > <a href="https://github.com/shivamshr01" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faGithub} className='text-black  text-2xl  md:text-2xl lg:text-4xl hover:scale-110'/></a></span>
            <span ><a href="https://www.linkedin.com/in/shivam-sharma-373a15246" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} className='text-black text-2xl md:text-2xl lg:text-4xl hover:scale-110' /></a></span>
        </div>
        <span className='text-black  text-[10px] md:text-sm  '>
            2025 Shivam Sharma All rights Reserved
        </span>
    </div>
  )
}
